<div class="ds-slider-holder">
  <div class="ds-slider">
    <div class="progress-bar" [style.width]="(100 / step) * activeStep + '%'"></div>
    <div class="thumb" [style.left]="(100 / step) * activeStep + '%'" [ngClass]="{ first: activeStep === 0, last: activeStep === step }"></div>
    <input type="range" min="0" [max]="step" [value]="value" (input)="onChangeSlider($event)" list="marks" />
  </div>
  <datalist id="marks" *ngIf="showLegends">
    <div></div>
    <div *ngFor="let legend of legends; let i = index" [style.left]="legendPositions[i]"> </div>
    <div></div>
  </datalist>
</div>
